import { useSamplesSurfaceMicrobialBaseDataDeleteMutation } from "@/services/backend/samples/api/surface-microbial-base-data-api";
import {
  SurfaceMicrobialBaseData,
  surfaceMicrobialBaseDataKey,
} from "@/services/backend/samples/types/sample-base-data";
import { DeleteSampleBaseDataDialog } from "@/services/backend/samples/components/delete-sample-base-data-dialog";

export function DeleteSurfaceMicrobialBaseDataDialog({
  baseData,
  onDeleted,
}: {
  baseData: SurfaceMicrobialBaseData;
  onDeleted?: () => void;
}) {
  const mutation = useSamplesSurfaceMicrobialBaseDataDeleteMutation();
  return (
    <DeleteSampleBaseDataDialog
      baseData={baseData}
      dataKey={surfaceMicrobialBaseDataKey}
      mutation={mutation}
      onDeleted={onDeleted}
    />
  );
}
